module.exports = __webpack_public_path__ + "img/rem5.ab9741ae.jpg";